import React from 'react'
import { useParams } from 'react-router-dom'
import { usePrismicDocumentsByUIDs } from '@prismicio/react'

import LoadingScreen from '../utils/LoadingScreen'
import { ArticleBody } from '../js/components/Article/ArticleBody'

export const Article = () => {
	const { slug } = useParams();
	const [documents, { state }] = usePrismicDocumentsByUIDs('article', [slug])

	return state !== 'loaded'
		? <LoadingScreen/>
		: <ArticleBody data={documents} />
};
